/**
 * IdleAttract — the kiosk's idle screen.
 *
 * Canonical name for the surface previously called `BoothAttract`.
 * Imports the implementation explicitly and re-exports it as the
 * default — the bare `export { default } from` form silently
 * resolved to `null` in the production webpack bundle at the
 * moment `setView('attract')` first fired, crashing the booth ~45s
 * into every session (P4 reliability audit finding, 2026-05-14).
 */
import BoothAttract from './BoothAttract';
export default BoothAttract;
